import type { Infer } from 'superstruct';
import {
	array,
	assign,
	boolean,
	nullable,
	number,
	object,
	optional,
	partial,
	string,
	union,
} from 'superstruct';

export const SalesforceLocation = assign(
	object({
		id: string(),
		name: string(),
		address: string(),
	}),
	partial(
		object({
			street: string(),
			city: string(),
			state: string(),
			zipCode: string(),
			marketingLocation: string(),
			isActive: boolean(),
		})
	)
);

export const SalesforceTargeting = assign(
	object({
		id: string(),
		name: string(),
		addresses: string(),
	}),
	partial(
		object({
			accountId: string(),
			radiusMiles: number(),
			cities: string(),
			zipCodes: string(),
			additionalNotes: string(),
			overallTargetingDetails: string(),
			targetingDetails: nullable(string()),
			primaryTargeting: boolean(),
		})
	)
);

export const SalesforceLocationData = union([
	SalesforceTargeting,
	SalesforceLocation,
]);

export const SalesforceLocations = array(SalesforceLocationData);

export type SalesforceLocation = Infer<typeof SalesforceLocation>;
export type SalesforceTargeting = Infer<typeof SalesforceTargeting>;
export type SalesforceLocations = Infer<typeof SalesforceLocations>;
export type SalesforceLocationData = Infer<typeof SalesforceLocationData>;

export const SalesforceAccount = partial(
	object({
		id: string(),
		avbId: string(),
		name: string(),
		businessName: optional(string()),
		website: optional(string()),
		facebookPageName: optional(string()),
		facebookLink: optional(string()),
		googleLink: optional(string()),
		websiteUrl: optional(string()),
	})
);

export type SalesforceAccount = Infer<typeof SalesforceAccount>;
